import _ from 'lodash';
import './changeDispatchTypeModal.scss';
import template from './changeDispatchTypeModal.html';

class ChangeDispatchTypeModal {
    /* @ngInject */
    constructor() {
        this.data = this.config.data;
        this.$close = this.config.close;
        this.$dismiss = this.config.dismiss;
    }

    submit() {
        this.$close(true);
    }

    close() {
        this.$close(false);
    }
}

export default {
    template: template,
    bindings: {
        config: '<'
    },
    controller: ChangeDispatchTypeModal
};